// Base URL of the AI agent server (the Agent_Server backend), which is a separate service
// from hellohousing's own API and is therefore not part of Autoload's Setting endpoints.
// Kept here rather than inline so the chat and the messaging AI assistant can't drift onto
// different hosts.
export const AI_AGENT_BASE_URL = window.location.href.includes('app.')
? 'https://app.hellohousing.de/api/bot-api'
: window.location.href.includes('dev.')
  ? 'https://dev.hellohousing.de/api/bot-api'
  : 'http://localhost:3001';

// Same host as AI_AGENT_BASE_URL, just http(s) -> ws(s) for the live-transcription socket
// (server.js's `wss`, routed by path — see /ws/transcribe in liveTranscriptionService.js).
export const AI_AGENT_WS_BASE_URL = AI_AGENT_BASE_URL.replace(/^http/, 'ws');

// Off for now: staging's reverse proxy (IIS + ARR in front of the bot-api host) doesn't yet
// forward WebSocket upgrades, so /ws/transcribe is unreachable there — NS_ERROR_WEBSOCKET_
// CONNECTION_REFUSED in the browser, not an app-level bug (confirmed live against a local
// instance). AiPromptDashboardTile.jsx and ChatApp.jsx both branch on this to fall back to
// the old record-then-POST-/transcribe flow (TranscribeModal + VoiceRecorder) instead of
// InlineVoiceRecorder. Flip back to true once IIS's ARR has "Enable WebSocket" turned on —
// no other code change should be needed on this side.
export const LIVE_TRANSCRIPTION_ENABLED = false;

export default AI_AGENT_BASE_URL;
